import { DateRange } from "../../../types"
import ButtonGroup, { ButtonProps } from "../button-group"

interface DaysFilterProps {
  className?: string
  range: number
  handleUpdateRange: (range: DateRange) => void
}

const DaysFilter = ({
  className = "",
  range,
  handleUpdateRange
}: DaysFilterProps) => {
  const FILTER_BUTTONS: ButtonProps[] = [
    {
      key: 1000,
      label: "All time",
      shortLabel: "All",
      disabled: false,
      onClick: () => handleUpdateRange(1000)
    },
    {
      key: 30,
      label: "30 Days",
      shortLabel: "30 D",
      disabled: false,
      onClick: () => handleUpdateRange(30)
    },
    {
      key: 7,
      label: "7 Days",
      shortLabel: "7 D",
      disabled: false,
      onClick: () => handleUpdateRange(7)
    },
    {
      key: 1,
      label: "24 hours",
      shortLabel: "24 H",
      disabled: false,
      onClick: () => handleUpdateRange(1)
    }
  ]

  return (
    <ButtonGroup
      className={className}
      buttons={FILTER_BUTTONS}
      active={range}
    />
  )
}

export default DaysFilter
